import { render, staticRenderFns } from "./VerifyAccount.vue?vue&type=template&id=1ab4e5ba&scoped=true&"
import script from "./VerifyAccount.vue?vue&type=script&lang=js&"
export * from "./VerifyAccount.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAccount.vue?vue&type=style&index=0&id=1ab4e5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab4e5ba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardTitle})
